<div
	class="formx-wrapper"
	[class.formx-error]="hasError"
	[class.formx-disabled]="control?.disabled"
>
	<!-- Label -->
	<span class="formx-label">
		{{ label }}
		@if (required) {
			*
		}
	</span>
	@switch (type) {
		@case ('email')
		@case ('tel')
		@case ('number')
		@case ('text')  {
			<!-- @case (["email", "tel", "number", "text"].includes(type) ? type : 0) { NOTE: Angular < 21 -->
			<!-- Text input -->
			<input
				class="formx-input"
				[type]="type"
				[formControl]="formControl"
				[placeholder]="placeholder"
				[attr.maxlength]="maxlength"
				[required]="required"
			/>
		}

		<!-- Datepicker input -->
		@case ("datepicker") {
			<input
				type="text"
				class="form-control formx-input"
				bsDatepicker
				[bsConfig]="bsConfig"
				[formControl]="formControl"
				[placeholder]="placeholder"
			/>
		}

		<!-- Select input -->
		@case ("select") {
			<select
				class="formx-input"
				[formControl]="formControl"
				[required]="required"
			>
				<option
					value=""
					disabled
					selected
					hidden
				>
					{{ placeholder }}
				</option>
				@for (opt of options; track opt) {
					<option [value]="opt.value">
						{{ translateLabels ? (opt.label | translate) : opt.label }}
					</option>
				}
			</select>
		}

		<!-- Radio input -->
		@case ("radio") {
			<mat-radio-group
				[formControl]="formControl"
				[disabled]="disabled"
				(change)="change.emit($event.value)"
				class="d-flex"
				[ngClass]="vertical ? 'flex-column' : 'gap-3'"
			>
				@for (opt of options; track opt) {
					<mat-radio-button [value]="opt.value">
						{{ translateLabels ? (opt.label | translate) : opt.label }}
					</mat-radio-button>
				}
			</mat-radio-group>
		}
	}

	<!-- Error message -->
	@if (hasError) {
		<div class="formx-error-text">{{ errorText }}</div>
	}

	<!-- Helper text -->
	@else if (helperText) {
		<div class="formx-helper">{{ helperText }}</div>
	}
</div>